// extracted by mini-css-extract-plugin
export default {"wrapper":"text-page_wrapper__UV3zl","title":"text-page_title__OcQqq","text":"text-page_text__Ugj8H"};